import { HttpClient, HttpHeaders } from '@angular/common/http';
// RxJs imports
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Service imports
import { HelperService } from '../../_services/shared-services/helper.service';
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
import { UserBiographyResultDto } from '../_models/user-biography-result-dto';
import { PortfolioAssignmentsResultDto } from '../_models/portfolio-assignments-result-dto';
// Constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/helper.service";
import * as i3 from "../../_services/shared-services/mp-cache-registration-service";
export class UserBiographyService {
    constructor(httpClient, helperService, cachingService) {
        this.httpClient = httpClient;
        this.helperService = helperService;
        this.cachingService = cachingService;
    }
    getUserBiography(params) {
        const url = `${URLConstants.ccUserBaseApiUrl}/bio${params.getQueryString()}`;
        this.cachingService.registerForCache(url, params.clearCache);
        const headers = this.cachingService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        return this.httpClient
            .get(url, { headers })
            .pipe(map((response) => plainToClass(UserBiographyResultDto, response)));
    }
    getUserAchivementBadge(achivement) {
        return this.helperService.getImageSafeUrlFromUrl(achivement.badgeImageUrl).pipe(catchError(() => {
            return of(achivement.unknownBadgeImage);
        }));
    }
    getUserPortfolioAssignment(userId, clearCache) {
        const url = `${URLConstants.ccUserBaseApiUrl}/portfolioassignments?userId=${userId}&clearCache=${clearCache}`;
        this.cachingService.registerForCache(url, clearCache);
        const headers = this.cachingService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        return this.httpClient
            .get(url, { headers })
            .pipe(map((response) => plainToClass(PortfolioAssignmentsResultDto, response)));
    }
    deleteUserProfile(params) {
        const url = `${URLConstants.ccUserBaseApiUrl}/bio/delete`;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: classToPlain(params)
        };
        return this.httpClient.delete(url, options);
    }
    approveUserProfile(params) {
        const url = `${URLConstants.ccUserBaseApiUrl}/bio/approve`;
        return this.httpClient.post(url, classToPlain(params));
    }
}
UserBiographyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserBiographyService_Factory() { return new UserBiographyService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.MPCacheRegistrationService)); }, token: UserBiographyService, providedIn: "root" });
